import React from "react";
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Row, Col, Modal, Icon, Steps } from 'antd'
import { Formik, FastField } from 'formik'
import typo, { MESSAGE } from '../../../../constants/dictionaries'
import { isEmpty } from "lodash";
import helper from "../../../../helper/helper"
import NumberField from "../../../Common/NumberField"
import AddTramModal from '../../FormKetQuaQuanTrac/QuanTrac/TramQuanTrac'
import DateField from "../../../Common/DateField"
import KetQuaQuanTrac from "../../FormKetQuaQuanTrac/QuanTrac/index"

// Components
import Input from '../../../Common/Input'
import Button from '../../../Buttons'
import styled from "styled-components";
import Select from "../../../Common/Select";
import message from "../../../Messages";
import Table from "../../../Table";
import constant from "../../../../constants/constant"
import moment from "moment";
import Api_quantrac from "../../../../api/api.quantrac";
import Api_spatial from "../../../../api/api.spatial"
import TextArea from "../../../Common/TextArea";
import Api from "../../../../api";
const { Step } = Steps;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const schema = Yup.object().shape({
  tramquantrac_id: Yup.string().required(typo.cscore_required),
  dotquantrac: Yup.string().required(typo.cscore_required),
  tpmt_ma: Yup.string().required(typo.cscore_required),
  dotquantrac_ten: Yup.string().required(typo.cscore_required),
});

class KetQuaQuanTracModal extends React.Component {
  constructor(props) {
    super(props);
    const { ngaylaymau, ngaynhanmau, ngayphantich } = props.initialValues || {};
    this.QTForm = React.createRef();
    this.TTForm = React.createRef();
    this.state = {
      dataThongSo: [],
      data: [],
      selectThongso: [],
      dataTram: [],
      setModal: false,
      dataDVD: [],
      data_qcvn_mdsd: [],
      thanh_phan_moi_truong: undefined,
      currentStep: 0,
      startValue: ngaylaymau ? moment(ngaylaymau) : undefined,
      endValue_BD: ngaynhanmau ? moment(ngaynhanmau) : undefined,
      endValue_KT: ngayphantich ? moment(ngayphantich) : undefined,
    };
  }

  componentDidMount() {
    const { mode, initialValues } = this.props
    this.GetTT_QDXP_TramQuanTracs_By_QD()
    this.GetApiQT_DonViDos()
    if (mode === "edit") {
      this.GetQT_ThongSos_By_TPMT(initialValues.tpmt_ma)
      this.GetQT_DMQCVN_MDSD(initialValues.tpmt_ma)
      if (initialValues.list_kqqt) {
        let thongsos = []
        let dataKQQT = JSON.parse(initialValues.list_kqqt)
        dataKQQT.map((item, index) => {
          let thongso = []
          thongso = item.thongso_id
          thongsos.push(thongso)
          item.heso_kq = item.heso_kq ? item.heso_kq : 1
          item.heso_kf = item.heso_kf ? item.heso_kf : 1.0
        })
        this.setState({
          data: dataKQQT.map((e, idx) => ({ ...e, stt: idx + 1 })),
          selectThongso: thongsos,
          thanh_phan_moi_truong: Number(initialValues.tpmt_ma)
        })
      }
    }
  }
  GetApiQT_DonViDos = () => {
    new Api()
      .GetQT_DonViDos({
        token: this.props.user.access_token,
        page: 0,
        size: 0
      })
      .then(res => {
        this.setState({
          dataDVD: res.data
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetQT_DMQCVN_MDSD = (tpmt_ma) => {
    new Api_quantrac()
      .GetQT_DMQCVN_MDSD({
        token: this.props.user.access_token,
        tpmt_ma: tpmt_ma
      })
      .then(res => {
        this.setState({
          data_qcvn_mdsd: res
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetTT_QDXP_TramQuanTracs_By_QD = () => {
    return new Api_quantrac()
      .GetTT_QDXP_TramQuanTracs_By_QD({
        token: this.props.user.access_token,
        idThongTinChung: this.props.idQuyetDinh,
        page: 0,
        size: 0
      })
      .then((res) => {
        this.setState({
          dataTram: res && res.data
        });
      }).catch(err => {
        message.error(err.message)
      })
  };
  GetQT_ThongSos_By_TPMT = (tpmt_ma) => {
    {
      tpmt_ma &&
        new Api_quantrac()
          .GetQT_ThongSos_By_TPMT({
            token: this.props.user.access_token,
            tpmt_ma: tpmt_ma,
          })
          .then(res => {
            this.setState({
              dataThongSo: res.map((item, index) => ({ ...item, thongso: item.tenThongSo + " (" + item.tenDonVi + ")" + " - " + item.kyHieuThongSo })),
            });
          }).catch(err => {
            message.error(err.message)
          });
    }
  };

  handleAddTram = (value) => {
    this.GetTT_QDXP_TramQuanTracs_By_QD()
    this.setState({
      setModal: false
    })
  }
  onChange = current => {
    const { mode } = this.props
    {
      mode !== "add" &&
        this.setState({ currentStep: current })
    }
  };
  next = () => {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  }

  prev = () => {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  }

  ThietLapMau = (tpmt) => {
    let datas = []
    const formQT = this.QTForm.current.handleSubmit()
    formQT.data && formQT.data.length > 0 && formQT.data.map((e, index) => {
      let objrender = {
        ...e,
        id: 0,
        dmqc_mdsd: e.dmqc_mdsd ? String(e.dmqc_mdsd) : "",
        giatri: 0,
      }
      datas.push(objrender)
    })

    const thietlapmau = { tpmt_ma: tpmt, kqqt: JSON.stringify(datas) }
    this.props.handleThietLap(thietlapmau)
  }
  getthietlapmau = (value) => {
    const { thietlapmau } = this.props
    thietlapmau.map((item) => {
      if (item.tpmt_ma === value) {
        let data_kqqt = JSON.parse(item.kqqt)
        let thongsos = []
        data_kqqt.map((v) => {
          let thongso = []
          thongso = v.thongso_id
          thongsos.push(thongso)
        })
        this.setState({
          data: data_kqqt.map((e, index) => ({
            ...e,
            stt: index + 1,
            miengiatri: "=",
            giatri: 0,
            dmqc_mdsd: e.dmqc_mdsd ? e.dmqc_mdsd.split(",") : ""
          })),
          selectThongso: thongsos
        })
      }
    })
  }
  disabledStartDate = startValue => {
    const { endValue_BD } = this.state;
    if (!startValue || !endValue_BD) {
      return false;
    }
    return startValue.valueOf() > endValue_BD.valueOf();
  };

  disabledEndDate = endValue_BD => {
    const { startValue } = this.state;
    if (!endValue_BD || !startValue) {
      return false;
    }
    return endValue_BD.valueOf() < startValue.valueOf();
  };

  disabledEndDate_KT = endValue_KT => {
    const { endValue_BD } = this.state;
    if (!endValue_KT || !endValue_BD) {
      return false;
    }
    return endValue_KT.valueOf() < endValue_BD.valueOf();
  };
  handleSubmit = () => {
    const { handleOk } = this.props
    const { state } = this.TTForm.current;
    const formQT = this.QTForm.current.handleSubmit()
    if (!isEmpty(state.errors)) {
      message.warning(MESSAGE.CSCORE_ERROR_THONG_TIN)
    } else {
      handleOk({ ...state.values, list_kqqt: JSON.stringify(formQT.data), ketqua_danhgia: formQT.ketqua, thongso_vuotnguongs: formQT.vuotnguong });
    }
  }
  render() {
    const { isOpen, handleCancel, handleOk, initialValues, mode, user, isEdit, idQuyetDinh, view } = this.props;
    const { data_qcvn_mdsd, thanh_phan_moi_truong, startValue, endValue_BD, endValue_KT, dataThongSo, data, selectThongso, dataTram, setModal, currentStep, dataDVD } = this.state
    return (
      <Modal
        visible={true}
        title={isEdit ? typo.cscore_cap_nhat_kqqt : typo.cscore_them_moi_kqqt}
        footer={false}
        onCancel={handleCancel}
        width="1100px"
        maskClosable={false}
      // centered
      >
        <div>
          <div>
            <Steps current={currentStep} onChange={this.onChange} style={{ width: "85%", textAlign: "center" }}>
              <Step title={typo.cscore_common_info} />
              <Step title={typo.cscore_ket_qua_QT} />
            </Steps>
            <Row className="mt-20" />
            <Row style={{ display: currentStep === 0 ? "block" : "none" }}>
              <Formik
                ref={this.TTForm}
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(value, actions) => {

                }}
                validationSchema={schema}
                render={({ handleChange, handleSubmit, values, errors, touched, setFieldValue, dirty }) => (
                  <form onSubmit={handleSubmit} autoComplete={false}>
                    <Row>
                      <Col span={12}>
                        <ControllerInput>
                          <FastField name="mau_kyhieu" render={({ field }) => (
                            <Input label={typo.cscore_key} mandatory={false}{...field} />)} />

                          <FastField name="mau_ten" render={({ field }) => (
                            <Input label={typo.cscore_sample_name} mandatory={false} {...field} />)} />

                          <FastField name="mau_tinhtrang" render={({ field }) => (
                            <Input label={typo.cscore_tinh_trang} mandatory={false}{...field} />)} />

                          <Select
                            dataSource={constant.THANH_PHAN_MOI_TRUONG}
                            defaultValue={values.tpmt_ma ? Number(values.tpmt_ma) : undefined}
                            onChange={(value) => {
                              setFieldValue("tpmt_ma", value);
                              this.setState({ thanh_phan_moi_truong: value })
                              this.GetQT_ThongSos_By_TPMT(value);
                              this.getthietlapmau(value)
                              this.GetQT_DMQCVN_MDSD(value)
                            }
                            }
                            placeholder={typo.cscore_thanh_phan_moi_truong}
                            label={typo.cscore_thanh_phan_moi_truong}
                            width="100%"
                            name="ten"
                            name_value="id"
                            key={values.tpmt_ma}
                            allowClear={true}
                          />

                          <Row type="flex">
                            <Col span={ view === "view" ? 24 : 21}>
                              <Select
                                dataSource={dataTram}
                                defaultValue={values.tramquantrac_id ? Number(values.tramquantrac_id) : undefined}
                                onChange={(value, name) => {
                                  setFieldValue("tramquantrac_id", value);
                                  setFieldValue("tramquantrac_ten", name.props.children);
                                }}
                                placeholder={typo.cscore_vi_tri_quan_trac}
                                label={typo.cscore_vi_tri_quan_trac}
                                width="100%"
                                name="tenTram"
                                name_value="id"
                                key={values.tramquantrac_id}
                              />
                            </Col>
                            <Col span={view === "view" ? 0 : 3}>
                              <Row type="flex" align="bottom" style={{ height: "100%", float: "right" }}>
                                <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                                  <Icon style={{ color: '#fff' }} type="plus" />
                                </Button>
                              </Row>
                            </Col>
                          </Row>

                          <FastField name="dotquantrac_ten" render={({ field }) => (
                            <Input label={typo.cscore_dot_quan_trac_ten} {...field} />)} />

                          <NumberField
                            label={typo.cscore_drawer_qt_batch}
                            id="dotquantrac"
                            min={0}
                            onChange={value => setFieldValue("dotquantrac", value)}
                            value={values.dotquantrac}
                          />
                        </ControllerInput>
                      </Col>
                      <Col span={12}>
                        <ControllerInput>
                          <FastField name="donvithuchien" render={({ field }) => (
                            <Input label={typo.cscore_don_vi_thuc_hien} mandatory={false}{...field} />)} />

                          <FastField name="nguoilaymaus" render={({ field }) => (
                            <Input label={typo.cscore_nguoi_lay_mau} mandatory={false}{...field} />)} />

                          <FastField name="nguoigiamsats" render={({ field }) => (
                            <Input label={typo.cscore_nguoi_giam_sat} mandatory={false}{...field} />)} />


                          <DateField
                            disabledDate={this.disabledStartDate}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_lay_mau)}
                            label={typo.cscore_ngay_lay_mau}
                            onChange={value => {
                              this.setState({ startValue: value });
                              setFieldValue("ngaylaymau", value && value.format())
                            }}
                            value={startValue}
                            mandatory={false}
                          />

                          <DateField
                            disabledDate={this.disabledEndDate}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_nhan_mau)}
                            label={typo.cscore_ngay_nhan_mau}
                            onChange={value => {
                              this.setState({ endValue_BD: value });
                              this.setState({ endValue_KT: undefined });
                              setFieldValue("ngaynhanmau", value && value.format());
                              setFieldValue("ngayphantich", undefined)
                            }}
                            value={endValue_BD}
                            mandatory={false}
                          />

                          <DateField
                            disabledDate={this.disabledEndDate_KT}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_phan_tich)}
                            label={typo.cscore_ngay_phan_tich}
                            onChange={value => {
                              this.setState({ endValue_KT: value });
                              setFieldValue("ngayphantich", value && value.format())
                            }}
                            value={endValue_KT}
                            mandatory={false}
                          />

                          <FastField name="mau_mota" render={({ field }) => (
                            <TextArea label={typo.cscore_note} mandatory={false}{...field} />)} />

                        </ControllerInput>
                      </Col>
                    </Row>
                  </form>
                )} />
            </Row>
            <div style={{ display: currentStep === 1 ? "block" : "none" }}>
              <KetQuaQuanTrac view={view} thanh_phan_moi_truong={thanh_phan_moi_truong} ref={this.QTForm} user={user} selectThongso={selectThongso} dataThongSo={dataThongSo} data={data} data_qcvn_mdsd={data_qcvn_mdsd} dataDVD={dataDVD}/>
            </div>
          </div>

          <div className="mt-20" />
          {mode !== "presentation" &&
            <Row>
              <Col span={12}>
                {mode === "add" &&
                  <div>
                    {currentStep !== 0 &&
                      <Button type="outline" onClick={() => this.prev()}><Icon type="left" />{typo.cscore_back}</Button>}
                    {currentStep === 0 &&
                      <Button type="outline" onClick={handleCancel}><Icon type="left" />{typo.cscore_back}</Button>}
                  </div>
                }
              </Col>
              <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                {thanh_phan_moi_truong && currentStep === 1 && view !== "view" &&
                  <Button type="outline" onClick={() => { this.ThietLapMau(thanh_phan_moi_truong) }}><Icon type="file-add" />{typo.cscore_thiet_lap_mau}</Button>}
                {mode !== "add" && view !== "view" &&
                  <Button type="submit" onClick={() => this.handleSubmit()} style={{ marginLeft: '10px' }} ><Icon type="save" />{typo.cscore_save}</Button>
                }
                {mode === "add" && currentStep === 1 &&
                  <Button type="submit" onClick={() => this.handleSubmit()} style={{ marginLeft: '10px' }} ><Icon type="save" />{typo.cscore_save}</Button>
                }
                {mode === "add" && currentStep === 0 &&
                  <Button type="outline" style={{ marginLeft: '10px' }} onClick={() => thanh_phan_moi_truong ? this.next() : message.warning(MESSAGE.CSCORE_WARNING_THANH_PHAN_MT)}><Icon type="right" />{typo.cscore_next}</Button>
                }
                {mode !== "add" &&
                  <Button type="cancel" style={{ marginLeft: '10px' }} onClick={handleCancel}><Icon type="arrow-right" />{typo.cscore_exit}</Button>
                }
              </Col>
            </Row>}

          {setModal &&
            <AddTramModal
              handleCancel={() => this.setState({ setModal: false })}
              handleAdd={this.handleAddTram}
              isOpen={setModal}
              idQuyetDinh={idQuyetDinh}
              thanhPhanMoiTruong={thanh_phan_moi_truong}
              ApiPost={new Api_quantrac().PostTT_QDXP_TramQuanTrac}
              ApiSpatial={new Api_spatial().LuuQuanTracTTKTDiem}
            />}
          {/*<DisplayFormikState error={errors} value={values} touched={touched}/>*/}
        </div>
      </Modal>
    )
  }
}
KetQuaQuanTracModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleThietLap: PropTypes.func.isRequired,
  /*Mode: add, edit, presentation*/
  mode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(KetQuaQuanTracModal)

const GroupWrapper = styled.div`
  max-width: 80%;
  padding: 5px 10px; 
`;

